class ValidationError {

    /// <summary>Indicates which input field this error relates to.</summary>
    public fieldName: string;

    /// <summary>Indicates why the request failed.</summary>
    /// <remarks>Switching to a string value. Enums were good for a few generic error types, but a string allows 
    /// projects to define speficic codes without recompiling and co-ordinating core libraries.</remarks>
    public errorCode: string;

    /// <summary>User friendly message to be displayed to the user.</summary>
    /// <remarks>This is designed as a fallback. Clients should map the error code to tailored user messages.</remarks>
    public errorMessage: string;
};

export { ValidationError };